export const getAvatar = (n: number) => {
  return `images/avatar/${n % 6}.png`;
};